// extracted by mini-css-extract-plugin
export default {"root":"W3Timer_root__FZ9Yt","expired":"W3Timer_expired__94qam","waiting":"W3Timer_waiting__f1KZl","paused":"W3Timer_paused__pWeDv","running":"W3Timer_running__sxvUe"};